import gsap from 'gsap';
import { CustomEase } from 'gsap/CustomEase';

gsap.registerPlugin(CustomEase);

const accordion = document.querySelector('.faq__question-list');

if (accordion) {
	const filterButtons = document.querySelectorAll('.faq__filter-button');
	let groups = gsap.utils.toArray('.faq__question:not(.--disposal)');
	let groups_disposal = gsap.utils.toArray('.faq__question.--disposal');
	let menus = gsap.utils.toArray('.faq__summary');
	let menuToggles = groups.map(createAnimation);
	let menuDisposalToggles = groups_disposal.map(createAnimation)


	menus.forEach((menu) => {
		menu.addEventListener('click', () => {
			toggleMenu(menu);
		});
	});

	function toggleMenu(clickedMenu) {
		menus.forEach((menu) => {
			if (menu !== clickedMenu) {
				menu.classList.remove('active');
			}
		});
		groups?.forEach((group) => {
			group.classList.remove('active');
		});
		groups_disposal?.forEach((group_d) => {
			group_d.classList.remove('active');
		});
		clickedMenu.classList.toggle('active');
		clickedMenu.parentElement.classList.toggle('active');
		menuToggles?.forEach((toggleFn) => toggleFn(clickedMenu));
		menuDisposalToggles?.forEach((toggleFn) => toggleFn(clickedMenu));
	}

	function createAnimation(element) {
		let menu = element.querySelector('.faq__summary');
		let box = element.querySelector('.faq__answer');

		gsap.set(box, {
			height: 'auto',
			paddingBottom: '2.2rem'
		});

		let animation = gsap
			.timeline()
			.from(box, {
				height: 0,
				marginTop: '0',
				paddingBottom: '0',
				duration: 0.5,
				ease: CustomEase.create('custom', '1, 0.01, 0, 1')
			})
			.reverse();

		return function (clickedMenu) {
			if (clickedMenu === menu) {
				animation.reversed(!animation.reversed());
			} else {
				animation.reverse();
			}
		};
	}

	filterButtons.forEach(button => {
		button.addEventListener('click', (e) => {
			filterButtons.forEach(button => {
				button.classList.remove('active')
			});

			e.currentTarget.classList.add('active');

			groups?.forEach(group => {
				if (group.dataset.id !== e.currentTarget.id) {
					group.style.display = 'none';
				} else {
					group.style.display = 'block';
				}
			})

			groups_disposal?.forEach(group_d => {
				const filters = group_d.dataset.filters.trim().split(' ')
	
					if(filters.includes(e.currentTarget.id)) {
						group_d.style.display = 'block';
					} else {
						group_d.style.display = 'none'
					}
				
			})
		})
	})
}
